import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/anijam99" target="_blank" rel="noreferrer"><GitHubIcon/></a>
      </div>
    </footer>
  );
}

export default Footer;